var handleSwipe = require('./handle-swipe');

(function ($) {
	var currentIndex = 0;
	var imageCount = $('.js-imageslider').find('img').length;
	var TOLERANCE_IN_PX = 40;
	var BTN_SIZE = 22;

	var getImageDescription = function () {
		var imageText = $('.js-imageslider-content[data-index="' + currentIndex + '"]')
			.find('img').data('description') || '';
		$('.js-image-text-content').text(imageText);
	};

	var lazyloadImage = function () {
		//Load next image and previous image, and current image if not loaded
		var nextImage = currentIndex === imageCount ? 0 : currentIndex + 1;
		var previousImage = currentIndex === 0 ? imageCount - 1 : currentIndex - 1;

		var imageSources = $('.js-imageslider').find('source').filter(function () {
			return $(this).closest('.js-imageslider-content').data('index') === currentIndex ||
				$(this).closest('.js-imageslider-content').data('index') === nextImage ||
				$(this).closest('.js-imageslider-content').data('index') === previousImage;
		});

		$.each(imageSources,
			function() {
				if (!$(this).attr('srcset')) {
					$(this).attr('srcset', $(this).data('src'));
					$(this).next('img').attr('src', $(this).data('src'));

					if ($('body').hasClass('ie-edge')) {
						$(this).next('img').css('background-image', 'url(' + $(this).data('src') + ')');
					}
				}
			});
	};

	var styleSliderButtons = function () {
		var moveX;
		var buttons = $('.js-imageslider-button');
		buttons.removeClass('hidden');

		if (currentIndex < 4 || imageCount < 8) {
			moveX = 0;
		} else if (currentIndex > imageCount - 4) {
			moveX = -BTN_SIZE * (imageCount - 7);
		} else {
			moveX = -BTN_SIZE * (currentIndex - 3);
		}

		//Shift all buttons x-axis
		buttons.css('transform', 'translateX(' + moveX + 'px)');
		if (imageCount < 8) {
			return;
		} else if (currentIndex < 4 ) {
			//Make buttons at edge small
			buttons.filter(function () {
				return $(this).data('index') === 6;
			}).css('transform', 'translateX(' + moveX + 'px) scale(0.6, 0.6)');

			//Hide buttons outside of edge
			buttons.filter(function () {
				return $(this).data('index') > 6;
			}).addClass('hidden');

		} else if (currentIndex > imageCount - 4) {

			buttons.filter(function () {
				return $(this).data('index') === imageCount - 7;
			}).css('transform', 'translateX(' + moveX + 'px) scale(0.6, 0.6)');

			buttons.filter(function () {
				return $(this).data('index') < imageCount - 7;
			}).addClass('hidden');

		} else {
			buttons.filter(function () {
				return $(this).data('index') === currentIndex + 3 ||
					$(this).data('index') === currentIndex - 3;
			}).css('transform', 'translateX(' + moveX + 'px) scale(0.6, 0.6)');

			buttons.filter(function () {
				return $(this).data('index') > currentIndex + 3 || $(this).data('index') < currentIndex - 3;
			}).addClass('hidden');
		}

		//Style active image button
		buttons.filter(function () {
			return $(this).data('index') === currentIndex;
		}).css('transform', 'translateX(' + moveX + 'px) scale(1.23, 1.23)');
	};

	var toggleImage = function (i) {
		if (i === imageCount) {
			i = 0;
		} else if (i === -1) {
			i = imageCount - 1;
		}
		$('.js-imageslider').find('img').removeClass('active');
		$('.js-imageslider-button').removeClass('active');
		$('.js-imageslider-button[data-index="' + i + '"]').addClass('active');
		$('[data-index="' + i + '"]').find('img').addClass('active');

		currentIndex = parseInt(i);

		$('.js-imageslider-count').text(currentIndex + 1 + '/' + imageCount);
		lazyloadImage();
		styleSliderButtons();
		getImageDescription();
	};

	$('.js-imageslider-button').on('click', function () {
		toggleImage($(this).data('index'));
	});

	$('.js-imageslider-next').on('click', function () {
		toggleImage(currentIndex + 1);
	});

	$('.js-imageslider-previous').on('click', function () {
		toggleImage(currentIndex - 1);
	});

	if ($('#image-slider').length > 0) {
		handleSwipe($('#image-slider')[0], TOLERANCE_IN_PX, function (e, direction) {
			e.preventDefault();

			switch (direction) {
				case 'left':
					toggleImage(currentIndex + 1);
					break;
				case 'right':
					toggleImage(currentIndex - 1);
					break;
			}
		});
	}

	toggleImage(currentIndex);
})(jQuery);
